<template>
    <input
        type="checkbox"
        :checked="state"
        :value="value"
        :name="name"
        v-bind="$attrs"
        v-on="listeners"
    />
</template>

<script>
import BaseInputComponent from '@/helpers/BaseInputComponent'
import {addEvent} from '@/helpers/Utils'

export default {
    name: 'oc-checkbox-input',
    extends: BaseInputComponent,
    props: {
        data: {
            type: [Array, Object, Boolean, String, Number],
            default: false
        },
        value: {
            type: [String, Number, Boolean],
            default: true
        },
        name: {
            type: [String, Number],
            default: null
        }
    },
    model: {
        prop: 'data',
        event: 'input'
    },
    created() {
        if( typeOf(this.data) === 'object' && this.name === null ) {
            console.error('<checkbox-input> If you use a data[v-model] param as object, you are required to provide a "name" property.');

            return
        }
    },
    computed: {
        listeners() {
            let listeners = Object.assign({}, this.inputListeners)

            // We remove original input event listener, cause its behavior will be customized and we will emit it programmatically.
            // By default, the input event is triggered when checkbox changes its states but we want to send customized data.
            // If we do not delete this it will send the original data and it will break custom checkbox logic.
            delete listeners.input

            listeners = addEvent(listeners, 'change', this.onChange)

            return listeners
        },
        state () {
            let data = this.data

            if (typeOf(data) === 'object') {
                if( ! data.hasOwnProperty(this.name) )
                    return false

                return data[this.name] === this.value
            } else if (Array.isArray(data)) {
                return data.indexOf( this.value ) > -1
            }

            return data === this.value
        }
    },
    methods: {
        onChange () {
            if (this.state) {
                this.uncheck()
            } else {
                this.check()
            }
        },
        check () {
            var data = this.data

            if (typeOf(data) === 'object') {
                data = Object.assign({}, data) // Clone object

                data[this.name] = this.value
                this.$emit('input', data, this.name)

                return
            } else if (Array.isArray(data)) {
                data = data.slice(0) // Copy Array.

                data.push(this.value)
                this.$emit('input', data, this.value)

                return
            }

            this.$emit('input', this.value, this.name)
        },
        uncheck () {
            var data = this.data

            if (typeOf(data) === 'object') {
                data = Object.assign({}, data) // Clone object

                delete data[this.name]
                this.$emit('input', data, this.name)

                return
            } else if (Array.isArray(data)) {
                data = data.slice(0)

                data.splice(data.indexOf(this.value), 1)
                this.$emit('input', data, this.value)

                return
            }

            if (this.value === true) {
                this.$emit('input', false, this.name)

                return
            }

            this.$emit('input', null, this.name)
        }
    }
}
</script>
